import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const About = () => {
    const features = [
        'Modern teknolojilerle geliştirme',
        'Müşteri odaklı çözümler',
        'Hızlı ve güvenilir teslimat',
        'Sürekli destek ve bakım'
    ];

    return (
        <section id="about" className="py-12 sm:py-16 lg:py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
                    <div className="order-2 lg:order-1">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 text-center lg:text-left">
                            Hakkımızda
                        </h2>
                        <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                            ABRH YAZILIM olarak yazılım sektöründe faaliyet göstermekteyiz.
                            Müşterilerimizin dijital dönüşüm süreçlerinde güvenilir bir iş ortağı olarak,
                            modern teknolojilerle yenilikçi ve sürdürülebilir çözümler sunuyoruz.
                            Kurumsal vizyonumuz, bilimsel temellere dayalı, teknoloji odaklı ve geleceğe yön veren projeler geliştirmektir.
                        </p>

                        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                            Akademik dünyada önemli çalışmalara imza atan ve <strong>Stanford Üniversitesi</strong> ile <strong>Elsevier</strong> iş birliğiyle hazırlanan
                            “<em>Dünyanın En Etkili İlk %2 Bilim İnsanları</em>”
                            arasına girerek <strong>Kariyer Boyu Etki Listesi</strong>’nde yer alan <strong>Prof. Dr. Ömer Faruk ERTUĞRUL</strong>’un akademik liderliğiyle,
                            araştırma ve bilimin ışığında yüksek kalite standartlarına sahip yazılım çözümleri üretiyoruz.
                            Deneyimli ekibimizle web uygulamaları, mobil uygulamalar ve kurumsal yazılım çözümleri geliştiriyor;
                            her projede müşteri memnuniyetini ve sürdürülebilir başarıyı ön planda tutuyoruz.
                        </p>

                        <div className="space-y-4">
                            {features.map((feature, index) => (
                                <div key={index} className="flex items-center">
                                    <CheckCircleIcon className="h-6 w-6 text-primary-500 mr-3" />
                                    <span className="text-gray-700">{feature}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="relative order-1 lg:order-2">
                        <img
                            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                            alt="Takım çalışması"
                            className="rounded-lg shadow-xl w-full"
                        />
                        <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-primary-500 text-white p-4 sm:p-6 rounded-lg shadow-lg">
                            <div className="text-2xl sm:text-3xl font-bold">50+</div>
                            <div className="text-xs sm:text-sm">Başarılı Proje</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
